import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  userData: any = null;

  constructor(private route: Router, private activatedRoute: ActivatedRoute) {
    const authSession = localStorage.getItem('_');
    if (!authSession) {
      this.route.navigate(['/login'], { queryParams: this.activatedRoute.snapshot.queryParams, queryParamsHandling: 'merge' });
    }
    try {
      var obj = JSON.parse(atob(authSession));
      if (obj.status == 1) {
        this.userData = obj;
      } else {
        this.route.navigate(['/login'], { queryParams: this.activatedRoute.snapshot.queryParams, queryParamsHandling: 'merge' });
      }
    } catch (error) {
      console.log(error);
      this.route.navigate(['/login'], { queryParams: this.activatedRoute.snapshot.queryParams, queryParamsHandling: 'merge' });
    }
  }

  checkExpire() {
    const currentTime = Math.floor(new Date().getTime() / 1000.0);
    const expireTime = this.userData?.expire || 0;
    if (currentTime > expireTime) {
      localStorage.removeItem('_');
      this.route.navigate(['/login'], { queryParams: this.activatedRoute.snapshot.queryParams, queryParamsHandling: 'merge' });
    }
  }

  getUsername() {
    this.checkExpire();
    return this.userData?.username ? this.userData.username : null;
  }

  isAdmin() {
    this.checkExpire();
    return this.userData?.is_admin == 1
  }

  getToken() {
    this.checkExpire();
    return this.userData?.token ? atob(this.userData.token) : null;
  }
}
